import { Injectable } from '@angular/core'
import { of } from 'rxjs'
import { MbProductByOriginalCodeAdapter } from './mb-product-by-original-code.adapter'
import { catchError } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class MbProductByOriginalCodeConnector {

  constructor (protected adapter: MbProductByOriginalCodeAdapter) {
  }

  getProductByOriginalCode (code: string) {
    return this.adapter.loadProductByOriginalCode(code).pipe(
      catchError(() => of(undefined))
    )
  }
}
